import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_REQUEST = `${MODULE_PREFIX}_GET_EVALUATION_ID_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_SUCCESS = `${MODULE_PREFIX}_GET_EVALUATION_ID_SUCCESS`;
export const questionnaireEvaluationGetEvaluationIdAction = requestData => ({
    type: QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationGetEvaluationIdSuccessAction = evaluationId => ({
    type: QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_SUCCESS,
    payload: evaluationId
});
//# sourceMappingURL=questionEvaluationGetEvaluationIdActions.js.map